import * as React from "react";

import { BreadcrumbsV2, Spinner } from "@graffer-inc/console-design-kit";
import { useDetailController } from "./use-detail-controller";
import { Feedback } from "../../../organisms/help/feedback";
import { Navigator } from "../../../organisms/help/navigator/navigator";
import "./detail.scss";
import { HelpTemplate } from "../../../template/help/default-template";
import { RichTextRender } from "../../../molecules/help/rich-text-render";
import { useRichTextRenderWithIds } from "../../../molecules/help/use-add-id-for-scroll";
import { ContentsHeadingList } from "../../../organisms/help/contents-heading-list/contents-heading-list";

export const HelpContentDetail: React.FC = () => {
  const { content, categoryList, productId, breadcrumbsProps, isLoading } =
    useDetailController();
  const html = useRichTextRenderWithIds({
    html: content?.metadata.content ?? "",
    enabledPageLink: true,
  });
  return (
    <HelpTemplate>
      {isLoading ? (
        <Spinner loading={isLoading} />
      ) : (
        <div className="help-content-detail-container">
          {content && (
            <>
              <BreadcrumbsV2.Breadcrumbs {...breadcrumbsProps} />
              <div className="help-content-detail-box">
                {content && content.metadata.content && (
                  <>
                    <div className="help-content-wrapper">
                      <ContentsHeadingList content={content} />
                      <RichTextRender html={html} enabledPageLink />
                      <Feedback contentPageURL={window.location.href} />
                    </div>
                    <Navigator
                      categoryList={categoryList}
                      productId={productId}
                    />
                  </>
                )}
              </div>
            </>
          )}
        </div>
      )}
    </HelpTemplate>
  );
};
